import o from "react";
import { getIconColor as c } from "./iconfont.es5474.js";
import p from "./iconfont.es5475.js";
const i = {
  display: "block"
}, x = ({ size: t = 16, color: e, useVw: n, useRem: a, disableSSR: l, style: r, ...m }) => {
  const d = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ o.createElement(p, { disableSSR: l }, /* @__PURE__ */ o.createElement("svg", { "data-icon-id": "icon-a-v31-morentouxiang", "data-icon-group": "GateUI", "data-icon-version": "0.8.1", viewBox: "0 0 1024 1024", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (a ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (a ? "rem" : "px"), style: d, ...m }, /* @__PURE__ */ o.createElement(
    "path",
    {
      d: "M511.99984 511.99984m-511.99984 0a511.99984 511.99984 0 1 0 1023.99968 0 511.99984 511.99984 0 1 0-1023.99968 0Z",
      fill: c(e, 0, "#EBEDF2")
    }
  ), /* @__PURE__ */ o.createElement(
    "path",
    {
      d: "M511.99984 575.99982a191.99994 191.99994 0 1 0 0-383.99988 191.99994 191.99994 0 0 0 0 383.99988z m0 63.99998c-204.799936 0-372.159884 93.535971-383.39188 211.359934A510.75184 510.75184 0 0 0 511.99984 1023.99968c152.575952 0 289.59991-66.751979 383.39188-172.639946C884.159724 733.535771 716.799776 639.9998 511.99984 639.9998z",
      fill: c(e, 1, "#D0D4DB")
    }
  )));
}, v = x;
export {
  v as default
};
